<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="total"
        :options.sync="options"
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, 200, 500] }"
        class="elevation-12"
        dense
    >
      <template v-slot:top>
        <div class="px-4">
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field
                  :label="$t('adminMailsDataTable.filters.mailIdentifier')"
                  v-model="filters.uid"
                  :clearable="true"
                  @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.inn"
                              :items="organizations"
                              :label="$t('common.labels.organization')"
                              :clearable="true"
                              item-text="name"
                              item-value="inn"
                              @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field
                  :label="$t('adminMailsDataTable.filters.receiver')"
                  v-model="filters.receiver"
                  :clearable="true"
                  @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <v-autocomplete v-model="filters.region"
                              :items="$store.getters.appRegions"
                              :item-value="item => item"
                              :item-text="item => item.name"
                              :label="$t('adminMailsDataTable.filters.region')"
                              :clearable="true"
                              @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-autocomplete v-model="filters.area"
                              :items="$store.getters.appAreas"
                              :item-value="item => item"
                              :item-text="item => item.name"
                              :label="$t('adminMailsDataTable.filters.district')"
                              :clearable="true"
                              @change="onFiltersChanged"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-menu
                  v-model="filterSendStartMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      :label="$t('adminMailsDataTable.filters.dispatchStartDate')"
                      v-model="filterSendStartDisplayValue"
                      readonly
                      v-on="on"
                      :clearable="true"
                      @input="onChangeFilterSendStartDisplayValue"
                  />
                </template>
                <v-date-picker
                    v-model="filters.sendFrom"
                    @change="onFilterSentStartChanged"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-menu
                  v-model="filterSendEndMenu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                      :label="$t('adminMailsDataTable.filters.dispatchEndDate')"
                      v-model="filterSendEndDisplayValue"
                      readonly
                      v-on="on"
                      :clearable="true"
                      @input="onChangeFilterSendEndDisplayValue"
                  />
                </template>
                <v-date-picker
                    v-model="filters.sendEnd"
                    @change="onFilterSendEndChanged"
                    no-title
                    scrollable
                    locale="ru"
                    first-day-of-week="1"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-select v-model="customFilters.perform"
                        :items="performTypeFilterOptions"
                        :clearable="true"
                        :label="$t('adminMailsDataTable.filters.status')"
                        @change="onCustomPerformFilterChanged"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="text-right">
              <v-btn large color="warning" class="me-2" dark @click="onExcelButtonClicked">{{ $t('adminMailsDataTable.actions.toExcel') }}</v-btn>
              <v-btn x-large color="primary" dark @click="onRefreshButtonClicked">{{ $t('adminMailsDataTable.actions.update') }}</v-btn>
            </v-col>
          </v-row>
          <v-dialog v-model="deleteMailDialog" :persistent="true" max-width="600px">
            <v-card>
              <v-card-title class="headline justify-center">{{ $t('adminMailsDataTable.deleteDialog.title') }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDeleteMailDialog">{{ $t('adminMailsDataTable.deleteDialog.cancel') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="deleteItemConfirm">{{ $t('adminMailsDataTable.deleteDialog.delete') }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>

      <template v-slot:item.id="scope">
        <v-btn color="primary" text :to="{name: 'track', params: {uid: `EHM${scope.item.id}`}}">{{ `EHM${scope.item.id}` }}</v-btn>
      </template>
      <template v-slot:item.receiver="scope">
        {{ scope.item.receiver }}
      </template>
      <template v-slot:item.region="scope">
        {{ scope.item.region.name }}
      </template>
      <template v-slot:item.area="scope">
        {{ scope.item.area.name }}
      </template>
      <template v-slot:item.recipient="scope">
        {{ scope.item.perform.recipient }}
      </template>
      <template v-slot:item.createdOn="scope">
        {{ scope.item.createdOn.format('DD.MM.YYYY HH:mm:ss') }}
      </template>
      <template v-slot:item.sentOn="scope">
        <template v-if="scope.item.sentOn">
          {{ scope.item.sentOn.format('DD.MM.YYYY HH:mm:ss') }}
        </template>
      </template>
      <template v-slot:item.state="scope">
        <template v-if="scope.item.isSent">
          <template v-if="scope.item.perform">
            {{ scope.item.perform.performType.name }}
          </template>
          <template v-else>
            {{ $t('adminMailsDataTable.states.inProcess') }}
          </template>
        </template>
        <template v-else>
          {{ $t('adminMailsDataTable.states.notSent') }}
        </template>
      </template>
      <template v-slot:item.performDate="scope">
        <template v-if="scope.item.perform">
          {{ scope.item.perform.performedOn.format('DD.MM.YYYY') }}
        </template>
      </template>
      <template v-slot:no-data>
        {{ $t('adminMailsDataTable.noMailsFound') }}
      </template>

      <template v-slot:item.actions="{item}" v-if="!$store.getters.isAdmin">
        <v-btn v-if="!item.isSent" icon small @click="deleteItem(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <template>
      <template v-if="isDeleteMailSuccess">
        <v-snackbar v-model="isDeleteMailSuccess"
                    :timeout="5000"
                    color="success"
        >
          <v-layout align-center pr-4>
            <v-layout column>
              <div>
                <strong>{{ $t('adminMailsDataTable.messages.deleteSuccess') }}</strong>
              </div>
            </v-layout>
          </v-layout>
        </v-snackbar>
      </template>
      <template v-else>
        <v-snackbar v-model="isDeleteMailSuccess"
                    :timeout="5000"
                    color="error"
        >
          <v-layout align-center pr-4>
            <v-layout column>
              <div>
                <strong>{{ $t('adminMailsDataTable.messages.deleteError') }}</strong>
              </div>
            </v-layout>
          </v-layout>
        </v-snackbar>
      </template>
    </template>
  </div>
</template>

<script>
import _ from 'underscore'
import Moment from 'moment'
import * as PerformTypes from '../../enums/perform.type'
import MailService from "@/services/mail.service";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import OrganizationService from "@/services/organization.service";
import Mappers from "@/mappers";
import formatter from "../../plugins/formatter";
import XLSX from "xlsx";
import Mapper from "@/mappers";

export default {
  name: "AdminMailsDataTable",
  props: {
    mails: {
      type: Array,
      default: () => {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customFilters: {
        perform: null
      },

      options: {
        sortBy: ['createdOn'],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 50,
      },
      filters: {
        uid: null,
        inn: null,
        receiver: null,
        region: '',
        area: null,
        start: null,
        end: null,
        sendFrom: null,
        sendEnd: null,
        performType: null,
        isPerformed: null,
        isExcel: false
      },
      isLoading: false,

      filterCreationStartMenu: false,
      filterCreationEndMenu: false,
      filterCreationStartDisplayValue: '',
      filterCreationEndDisplayValue: '',
      filterSendStartMenu: false,
      filterSendEndMenu: false,
      filterSendStartDisplayValue: '',
      filterSendEndDisplayValue: '',

      currentItem: null,
      deleteMailDialog: false,
      isDeleteMailSuccess: false,

      organizations: [],
    };
  },
  computed: {
    performTypeFilterOptions() {
      const options = []
      _.each(PerformTypes, performType => {
        options.push({
          text: performType.name,
          value: performType
        })
      })

      return options
    },
    items() {
      let number = 1;
      let skip = this.skip;
      return _.map(this.mails, m => {
        m.displayNumber = skip + (number++)
        return m
      })
    },
    headers() {
      const headers = [];

      headers.push({
        text: this.$t('tableHeaders3.number'),
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })

      headers.push({
        text: this.$t('common.labels.identifier'),
        align: 'center',
        sortable: false,
        value: 'id'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.sender'),
        align: 'center',
        sortable: false,
        value: 'creatorUser.organization.name'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.receiver'),
        align: 'left',
        sortable: false,
        value: 'receiver'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.region'),
        align: 'center',
        sortable: true,
        value: 'region'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.district'),
        align: 'center',
        sortable: true,
        value: 'area'
      })

      headers.push({
        text: this.$t('tableHeaders3.address'),
        align: 'left',
        sortable: false,
        value: 'address'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.recipient'),
        align: 'center',
        sortable: true,
        value: 'perform.recipient'
      })

      headers.push({
        text: this.$t('tableHeaders3.pageCount'),
        align: 'center',
        sortable: false,
        value: 'pagesCount'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.creationDate'),
        align: 'center',
        sortable: true,
        value: 'createdOn'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.dispatchDate'),
        align: 'center',
        sortable: true,
        value: 'sentOn'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.filters.status'),
        align: 'center',
        sortable: false,
        value: 'state'
      })

      headers.push({
        text: this.$t('adminMailsDataTable.table.deliveryReturnDate'),
        align: 'center',
        sortable: false,
        value: 'performDate'
      })

      headers.push({
        text: '',
        align: 'center',
        sortable: false,
        value: 'actions'
      })

      return headers;
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    },
  },
  methods: {
    onExcelButtonClicked(){
      this.isLoading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc} = this.options;
      const {uid, inn, receiver, region, area, start, end, sendFrom, sendEnd, performType, isPerformed} = this.filters;

      MailService.get({
        skip: 0,
        limit: this.total,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        uid: uid,
        inn: inn,
        region: region,
        receiver: receiver,
        area: area,
        createdStart: start ? Moment(start, 'YYYY-MM-DD') : null,
        createdEnd: end ? Moment(end, 'YYYY-MM-DD') : null,
        sentStart: sendFrom ? Moment(sendFrom, 'YYYY-MM-DD') : null,
        sentEnd: sendEnd ? Moment(sendEnd, 'YYYY-MM-DD') : null,
        performType: performType,
        isPerformed: isPerformed
      })
          .then(response => {
            var mails = _.map(response.data.Records, mailViewModel => {
              return Mapper.mapMail(mailViewModel)
            })

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet([
              [
                this.$t('tableHeaders3.number'),
                this.$t('common.labels.identifier'),
                this.$t('adminMailsDataTable.table.sender'),
                this.$t('adminMailsDataTable.filters.receiver') + 'w',
                this.$t('adminMailsDataTable.filters.region'),
                this.$t('adminMailsDataTable.filters.district'),
                this.$t('tableHeaders3.address'),
                this.$t('adminMailsDataTable.table.recipient'),
                this.$t('tableHeaders3.pageCount'),
                this.$t('adminMailsDataTable.table.creationDate'),
                this.$t('adminMailsDataTable.table.dispatchDate'),
                this.$t('adminMailsDataTable.filters.status'),
                this.$t('adminMailsDataTable.table.deliveryReturnDate')
              ],
            ]);

            worksheet['!cols'] = [{ width: 10 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 20 }, { width: 25 }, { width: 20 }];
            worksheet['!rows'] = [{ hpx: 25 }];

            for (let i = 1; i <= 10; i++) {
              const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i - 1 });
              const cell = worksheet[cellAddress];
              if (!cell) continue;

              cell.s = {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
                fill: {
                  fgColor: { rgb: '4472C4' },
                },
                border: {
                  top: { style: 'thin', color: { rgb: '000000' } },
                  bottom: { style: 'thin', color: { rgb: '000000' } },
                  left: { style: 'thin', color: { rgb: '000000' } },
                  right: { style: 'thin', color: { rgb: '000000' } },
                },
              };
            }
            console.log(mails)
            mails.forEach((item, index) => {
              const row = [
                index + 1,
                item.id ? item.id : '',
                item.creatorUser.unit ? item.creatorUser.unit.name : '',
                item.receiver ? item.receiver : '',
                item.region.name ? item.region.name : '',
                item.area.name ? item.area.name : '',
                item.address ? item.address : '',
                item.perform ? item.perform.recipient : '',
                item.pagesCount ? item.pagesCount : '',
                item.createdOn.toString() ? item.createdOn.toString() : '',
                item.sentOn ? item.sentOn.toString() : '',
                item.perform ? item.perform.performType.name : this.$t('adminMailsDataTable.states.notSent'),
                item.perform ? item.perform.createdOn.toString() : '',
              ];

              XLSX.utils.sheet_add_aoa(worksheet, [row], { origin: index + 1 });
            });

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'mails.xlsx');
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          })
          .finally(() => {
            this.isLoading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })


    },
    deleteItem(item) {
      this.currentItem = item;
      this.deleteMailDialog = true
    },
    deleteItemConfirm() {
      this.deleteMail(this.currentItem.id)
      this.currentItem = null
      this.deleteMailDialog = false
    },
    closeDeleteMailDialog() {
      this.deleteMailDialog = false
    },
    deleteMail(id) {
      MailService.delete(id)
          .then(() => {
            this.isDeleteMailSuccess = true
          })
      this.updateItems();
    },
    updateItems() {
      this.$emit("update", this.options, this.filters)
      this.updateRouteQuery(this.options, this.filters, this.customFilters)
    },
    updateRouteQuery(options, filters, customFilters) {
      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {uid, inn, receiver, region, area, start, end} = filters;
      const {perform} = customFilters

      let routeQuery = {}

      // options
      if (!sortBy) {
        this.options.sortBy = ['createdOn']
      }
      if (!sortDesc) {
        this.options.sortDesc = [true]
      }
      if (!page) {
        this.options.page = 1
      }
      if (!itemsPerPage) {
        this.options.itemsPerPage = 50
      }

      routeQuery.sortBy = sortBy?.length === 1 ? sortBy[0] : sortBy
      routeQuery.sortDesc = sortDesc?.length === 1 ? sortDesc[0] : sortDesc
      routeQuery.page = page ?? page
      routeQuery.itemsPerPage = itemsPerPage ?? itemsPerPage

      // filters
      if (region) {
        routeQuery.region = region._id
      }
      if (area) {
        routeQuery.area = area._id
      }
      if (uid) {
        routeQuery.uid = uid
      }
      if (inn) {
        routeQuery.inn = inn
      }
      if (receiver) {
        routeQuery.receiver = receiver
      }
      if (perform) {
        routeQuery.perform = perform._id
      }
      if (start) {
        routeQuery.start = start
      }
      if (end) {
        routeQuery.end = end
      }

      this.$router.push({ name: this.$route.name, query: routeQuery }).catch(error => {
        console.log(error);
      });
    },


    onFiltersChanged() {
      if (this.options.page !== 1)
        this.options.page = 1;
      else
        this.updateItems();
    },
    onRefreshButtonClicked() {
      this.updateItems();
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.filterCreationStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterCreationStartDisplayValue = ''
      }

      this.filterCreationStartMenu = false
      this.updateItems()
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.filterCreationEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterCreationEndDisplayValue = ''
      }

      this.filterCreationEndMenu = false
      this.updateItems()
    },
    onChangefilterCreationStartDisplayValue() {
      this.filters.start = null;
      this.updateItems()
    },
    onChangefilterCreationEndDisplayValue() {
      this.filters.end = null;
      this.updateItems()
    },
    onFilterSentStartChanged() {
      if (this.filters.sendFrom) {
        this.filterSendStartDisplayValue = Moment(this.filters.sendFrom, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterSendStartDisplayValue = ''
      }

      this.filterSendStartMenu = false
      this.updateItems()
    },
    onFilterSendEndChanged() {
      if (this.filters.sendEnd) {
        this.filterSendEndDisplayValue = Moment(this.filters.sendEnd, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.filterSendEndDisplayValue = ''
      }

      this.filterSendEndMenu = false
      this.updateItems()
    },
    onChangeFilterSendStartDisplayValue() {
      this.filters.sendFrom = null;
      this.updateItems()
    },
    onChangeFilterSendEndDisplayValue() {
      this.filters.sendEnd = null;
      this.updateItems()
    },
    onCustomPerformFilterChanged() {
      this.filters.performType = null
      this.filters.isPerformed = null

      if (this.customFilters.perform !== null && this.customFilters.perform !== undefined) {
        if (this.customFilters.perform._id === -2) {
          this.filters.isPerformed = false
        } else if (this.customFilters.perform._id === -1) {
          this.filters.isPerformed = true
        } else {
          this.filters.performType = this.customFilters.perform
        }
      }

      this.onFiltersChanged()
    },
    loadOrganizations() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      OrganizationService.getOrganizations({})
          .then(response => {
            this.organizations = _.map(response.data.Records, o => {
              return Mappers.mapOrganization(o?.Organization)
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
  },
  created() {
    this.loadOrganizations()

    this.filters.sendFrom = Moment().format('YYYY-MM-DD');
    this.filters.sendEnd = Moment().format('YYYY-MM-DD');
    this.filterSendStartDisplayValue = Moment(this.filters.sendFrom, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.filterSendEndDisplayValue = Moment(this.filters.sendEnd, 'YYYY-MM-DD').format('DD.MM.YYYY')

    if (this.$route.query) {
      // options
      if (this.$route.query.sortBy) {
        this.options.sortBy = []
        const sortBy = this.$route.query.sortBy
        this.options.sortBy.push(sortBy)
      }
      if(this.$route.query.sortDesc) {
        this.options.sortDesc = []
        let val = formatter.stringToBoolean(this.$route.query.sortDesc)
        this.options.sortDesc.push(val)
      }
      if(this.$route.query.page) {
        this.options.page = formatter.stringToNumber(this.$route.query.page)
      }
      if(this.$route.query.itemsPerPage) {
        this.options.itemsPerPage = formatter.stringToNumber(this.$route.query.itemsPerPage)
      }

      // filters
      if(this.$route.query.region) {
        this.filters.region = _.find(this.$store.getters.appRegions, r => { return r.id === formatter.stringToNumber(this.$route.query.region) })
      }
      if(this.$route.query.area) {
        this.filters.area = _.find(this.$store.getters.appAreas, a => { return a.id === formatter.stringToNumber(this.$route.query.area) })
      }
      if (this.$route.query.uid) {
        this.filters.uid = this.$route.query.uid
      }
      if (this.$route.query.inn) {
        this.filters.inn = this.$route.query.inn
      }
      if (this.$route.query.receiver) {
        this.filters.receiver = this.$route.query.receiver
      }
      if (this.$route.query.start) {
        this.filters.start = this.$route.query.start
        this.filterCreationStartDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }
      if (this.$route.query.end) {
        this.filters.end = this.$route.query.end
        this.filterCreationEndDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }
      if (this.$route.query.perform) {
        this.customFilters.perform = _.find(PerformTypes, p => {return p._id === formatter.stringToNumber(this.$route.query.perform)})
        this.onCustomPerformFilterChanged()
      }
      this.isLoading = this.loading
    }
  },
  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    }
  }
}
</script>

<style scoped>

</style>